import React, { Component } from "react";
import Close from "../../../../../Icons/Close";
import postImgUrl from "../../../../../styles/img/media-blue.svg";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import UploadPhoto from "./UploadPhoto";
import Empty from "./Empty";
import imgUrlAvatar from "../../../../../styles/img/enfant-avatar.jpg";
import { connect } from "react-redux";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import CameraComponent from "../../../../../../src/components/CardActionsComponent"
import IcrecheCamera from "./IcrecheCamera";
import jwt_decode from 'jwt-decode'
const divStyleAvatar = {
  background: "url(" + imgUrlAvatar + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",

};
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);
class ModalePhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadPhoto: false,
      cameraPhoto: false,
      src: null,
      tabActive: "depart-tab",
      onlyView: false,
      tabToUpdate: "",
      isUpdate: false,
      file: null,
      fileId: null,
      styleFadeIn: true,
      isUpload: false,
      croppedFile: "",
      facingMode: "environment",
    };
    this.handleTab = this.handleTab.bind(this);
    this.activeUpload = this.activeUpload.bind(this);
    this.activeCamera = this.activeCamera.bind(this);
    this.uploadPhoto = this.uploadPhoto.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);
    this.closeUploadModal = this.closeUploadModal.bind(this);
    this.handleTakePhoto = this.handleTakePhoto.bind(this);
  }
  handleTakePhoto(file) {
    this.setState({
      file: file,
      tabActive: "arrivee-tab",
      isUpload: true,
    });
  }

  getCroppedImage(file) {
    this.setState({ croppedFile: file });
  }
  activeUpload(string) {
    return this.state.tabActive === string ||
      this.state.tabActive === "arrivee-tab"
      ? "active"
      : "";
  }
  activeCamera(string) {
    return this.state.tabActive === string ||
      this.state.tabActive === "depart-tab"
      ? "active"
      : "";
  }
  handleTab = (string) => {
    this.setState({ tabActive: string });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ file: reader.result, isUpload: true })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  switchTabs(tab) {
    switch (tab) {
      case "arrivee-tab":
        return (
          <UploadPhoto
            values={this.state}
            onSelectFile={this.onSelectFile}
            uploadPhoto={this.uploadPhoto}
            photo={this.state.file}
            getCroppedImage={this.getCroppedImage}
            isUpload={this.state.isUpload}
          />
        );
      case "depart-tab":
        return (
          <IcrecheCamera
            goToCorpImageTab={(blob) => {
              this.setState({ isUpload: true, file: URL.createObjectURL(blob) });
              this.handleTab("arrivee-tab");
            }}
          />
        );

      default:
        return <Empty />;
    }
  }
  uploadPhoto = (e) => {
    this.props.uploadPhoto(this.state.croppedFile);
    this.props.onCloseModalePhoto();
  };
  componentDidMount() {
    this.setState({
      file: this.props.photo,
    });
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  closeUploadModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModalePhoto();
    }, 400);


  };
  render() {
    return (
      <StyleRoot>
        <div
          className="modal show modal-skin "
          style={{ display: "show", background: "rgba(0, 76, 197, 0.7)" }}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog " role="document" style={{ top: 140 }}>
            <div className="modal-content">
              <button
                onClick={this.closeUploadModal}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <div className="mt-3 d-flex align-items-center justify-content-center"
                  style={{ padding: "10px" }}>
                  <bouton
                    className={`btn-filter ${this.activeCamera("depart-tab")}`}
                    style={{ cursor: "pointer" }}
                    id="depart-tab"
                    onClick={() => this.handleTab("depart-tab")}
                    role="tab"
                    aria-controls="contact"
                    aria-selected="false"
                  >
                    <span>Camera </span>
                  </bouton>

                  <span><div>
                    <div class="d-flex justify-content-center ">
                      <div class="input-file-style mr-3">
                        <input
                          type="file"
                          class="d-none"
                          accept="image/png, image/jpeg,image/bmp"
                          onChange={this.props.onSelectFile}
                        />
                        <label
                          htmlFor="add-media"
                          class="btn-white btn-border btn-label m-0"
                          className={`btn-filter ${this.activeUpload("arrivee-tab")}`}
                          style={{ cursor: "pointer", marginBottom: "0" }}
                          id="arrivee-tab-1"
                          onClick={() => this.handleTab("arrivee-tab")}
                          role="tab"
                          aria-controls="contact"
                          aria-selected="false"
                        >
                          <Img type="image/svg+xml" className="img-fluid" alt="" />{" "}
                          Galerie{" "}
                        </label>
                      </div>
                    </div>
                  </div></span>
                </div>
                <div className="tab-content" id="myTabContent">
                  {this.switchTabs(this.state.tabActive)}

                </div>

              </div>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, {})(ModalePhoto);
